import { AfterViewInit, EventEmitter, OnDestroy, } from '@angular/core';
import { ControlContainer, Validators, } from '@angular/forms';
import { enumMapper } from '@models';
import { UserGroupField } from '@pages/users/modals';
import { DirectoryService, SearchContext, } from '@services';
import { UI_AD_SEARCH_REGEX } from '@validators';
import { BehaviorSubject, Subject, } from 'rxjs';
import { finalize, map, takeUntil, tap, } from 'rxjs/operators';
var AdSearchComponent = /** @class */ (function () {
    function AdSearchComponent(controlContainer, _directoryService) {
        var _this = this;
        this.controlContainer = controlContainer;
        this._directoryService = _directoryService;
        this.domainHint = 'user_import_modal_form_domain_name_hint';
        this.userOrGroupHint = 'user_import_modal_form_group_name_hint';
        this.isLoading = new BehaviorSubject(true);
        this.selected = new EventEmitter();
        this.restrictInputRegex = UI_AD_SEARCH_REGEX;
        this.UserGroupField = UserGroupField;
        this.searchContext = SearchContext.All;
        this.searchContextOptions = enumMapper(SearchContext, {
            resourceKey: 'SearchContext',
        });
        this._destroyed$ = new Subject();
        this.adSearchFactory = function (searchContext) { return function (searchTerm) {
            var domain = _this.form.get(UserGroupField.Domain).value[0];
            return _this._directoryService
                .adSearchFactory(domain && domain.id, searchTerm, searchContext);
        }; };
        this.availableDomains$ = this._directoryService
            .getDomains()
            .pipe(finalize(function () {
            _this.isLoading.next(false);
            _this.isLoading.complete();
        }), map(function (domains) { return domains.map(function (domain) { return ({
            id: domain.name,
            text: domain.name,
            data: domain,
        }); }); }), tap(function (domains) {
            var domain = domains.find(function (d) { return d.data.isDefault; }) || domains[0];
            _this.form.get(UserGroupField.Domain).setValue([domain]);
        }));
    }
    Object.defineProperty(AdSearchComponent.prototype, "form", {
        get: function () { return this.controlContainer.control; },
        enumerable: true,
        configurable: true
    });
    AdSearchComponent.prototype.ngAfterViewInit = function () {
        var _this = this;
        var _a = [
            this.form.get(UserGroupField.Domain),
            this.form.get(UserGroupField.UserName),
            this.form.get(UserGroupField.Type),
        ], domain = _a[0], username = _a[1], type = _a[2];
        username.setValidators(Validators.required);
        domain.valueChanges.pipe(takeUntil(this._destroyed$)).subscribe(function () { return username.setValue([]); });
        username.valueChanges.pipe(takeUntil(this._destroyed$)).subscribe(function (value) {
            if (type) {
                type.setValue(value && value[0] && value[0].type);
            }
            _this.selected.emit(username.value && username.value[0]
                ? {
                    domain: domain.value[0].id,
                    username: username.value[0].id,
                }
                : undefined);
        });
    };
    AdSearchComponent.prototype.ngOnDestroy = function () {
        this._destroyed$.next();
        this._destroyed$.complete();
    };
    return AdSearchComponent;
}());
export { AdSearchComponent };
